import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * Floating "Install app" prompt for PWA.
 * Shows only when:
 *  - The browser fired beforeinstallprompt
 *  - User has not dismissed it before (localStorage)
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("pwa-install-dismissed");
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!dismissed) setVisible(true);
    };
    const installedHandler = () => {
      setInstalled(true);
      setVisible(false);
      localStorage.setItem("pwa-install-dismissed", "installed");
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", installedHandler);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
    }
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem("pwa-install-dismissed", new Date().toISOString());
    setVisible(false);
  };

  if (!visible || installed) return null;

  return (
    <div
      data-testid="pwa-install-prompt"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm z-[60] panel-strong p-4"
      style={{ boxShadow: "0 0 30px rgba(34,211,238,0.25)" }}
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-sm flex items-center justify-center"
          style={{ background: "rgba(99, 102, 241, 0.15)", border: "1px solid var(--cyan)" }}>
          <Download className="w-5 h-5" style={{ color: "var(--cyan)" }} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="label-mono mb-0.5" style={{ color: "var(--cyan)" }}>// INSTALAR APP</div>
          <div className="text-sm font-semibold text-slate-100">Inconti ERP en tu pantalla de inicio</div>
          <div className="text-xs text-slate-400 mt-0.5">Acceso rápido a asistencia y gastos desde la obra, incluso sin internet.</div>
          <div className="flex gap-2 mt-3">
            <button
              data-testid="pwa-install-btn"
              onClick={install}
              className="btn-primary px-3 py-1.5 text-[11px] uppercase tracking-widest font-semibold rounded-sm flex items-center gap-1.5"
            >
              <Download className="w-3 h-3" /> Instalar
            </button>
            <button
              data-testid="pwa-dismiss-btn"
              onClick={dismiss}
              className="btn-ghost px-3 py-1.5 text-[11px] uppercase tracking-widest font-semibold rounded-sm"
            >
              Después
            </button>
          </div>
        </div>
        <button onClick={dismiss} className="text-slate-500 hover:text-cyan-300 flex-shrink-0">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
